import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { RecoveryAccessComponent } from './recovery-access/recovery-access.component';
import { SendEmailSuccessComponent } from './send-email-success/send-email-success.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ChangePasswordIncorrectComponent } from './change-password-incorrect/change-password-incorrect.component';
import { ChangePasswordSuccessComponent } from './change-password-success/change-password-success.component';

import { AUTH_PATHS } from './auth';
import { LoginV2Component } from './login-v2/login-v2.component';
import { LoginV2CallbackComponent } from './login-v2-callback/login-v2-callback.component';
import { LogoutV2Component } from './logout-v2/logout-v2.component';
import { LegacyLoginGuard } from './legacy-login.guard';

export const routes: Routes = [
  {
    path: AUTH_PATHS.login_legacy,
    component: LoginComponent,
    canActivate: [LegacyLoginGuard],
    data: { animation: 'LoginPage' },
  },
  {
    path: AUTH_PATHS.login,
    component: LoginV2Component,
    data: { animation: 'LoginPage' },
  },
  {
    path: AUTH_PATHS.login_callback,
    component: LoginV2CallbackComponent,
    data: { animation: 'LoginPage' },
  },
  {
    path: AUTH_PATHS.logout,
    component: LogoutV2Component,
    data: { animation: 'LoginPage' },
  },
  {
    path: AUTH_PATHS.recovery_access,
    component: RecoveryAccessComponent,
    data: { animation: 'RecoveryPage' },
  },
  {
    path: AUTH_PATHS.send_email_success,
    component: SendEmailSuccessComponent,
    data: { animation: 'SendEmailSuccessPage' },
  },
  {
    path: AUTH_PATHS.change_password,
    component: ChangePasswordComponent,
    data: { animation: 'ChangePasswordPage' },
  },
  {
    path: AUTH_PATHS.change_password_incorrect,
    component: ChangePasswordIncorrectComponent,
    data: { animation: 'ChangePasswordIncorrectPage' },
  },
  {
    path: AUTH_PATHS.change_password_success,
    component: ChangePasswordSuccessComponent,
    data: { animation: 'ChangePasswordSuccessPage' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
